import Api from "../../utils/Api";
import { modifyError } from "../../utils/Validation/ModifyErrros";

export const createDataInput = async (slug, data) => {
  try {
    let res = await Api.post(`${slug}`, data);
    return res?.data;
  } catch (e) {
    let error = modifyError(e);
    return { error: error.message };
  }
};

export const getDataInput = async (slug, query) => {
  try {
    let res = await Api.get(`${slug}`, {
      params: query,
    });
    return res?.data || [];
  } catch (e) {
    return { error: "Something Wrong" };
  }
};

export const updatePositionDataInput = async (slug, banners, query) => {
  try {
    let res = await Api.patch(`${slug}/relocate-position`, banners, {
      params: query,
    });

    return res?.data || [];
  } catch (e) {
    return { error: "Something Wrong" };
  }
};
export const getOnDataInput = async (slug, id) => {
  try {
    let res = await Api.get(`${slug}/${id}`);
    return res?.data || [];
  } catch (e) {
    return { error: "Something Wrong" };
  }
};

export const deleteDataInput = async (slug, id) => {
  try {
    let res = await Api.delete(`${slug}/` + id);
    return res?.data || [];
  } catch (e) {
    return { error: "Failed to delete" };
  }
};
export const getDataLocation = async (slug, query) => {
  try {
    let res = await Api.get(`${slug}/location`, {
      params: query,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    return res?.data || [];
  } catch (e) {
    return { error: "Something Wrong" };
  }
};

export const updateDataInput = async (slug, id, data) => {
  try {
    let res = await Api.patch(`${slug}/` + id, data);
    return res?.data || [];
  } catch (e) {
    return { error: "Failed to Update" };
  }
};
